import { render, staticRenderFns } from "./SkuSetting.vue?vue&type=template&id=f45b21ce"
import script from "./SkuSetting.vue?vue&type=script&lang=js"
export * from "./SkuSetting.vue?vue&type=script&lang=js"
import style0 from "./SkuSetting.vue?vue&type=style&index=0&id=f45b21ce&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports